import React, { useContext } from 'react';
import TimeTableContext from '../../context/timeTableContext'

const SelectTeacher = () => {
    const context = useContext(TimeTableContext);


    return (
        <div className="form-group">
            <select onChange={(e) => { context.dispatch({ type: "SET_TEACHER_ID", payload: e.target.value }) }} className="form-control" id="exampleFormControlSelect1">
                <option value={""}>בחר מורה</option>

                {
                    context.state.teachers.sort(function (a, b) {
                        if (a.name < b.name) { return -1; }
                        if (a.name > b.name) { return 1; }
                        return 0;
                    }).map((teacher) => {
                        let selected = teacher._id === context.state.teacherId ? "selected" : "";
                        return (
                            <option key={teacher._id} value={teacher._id} selected={selected}>
                                {teacher.name}
                            </option>
                        )
                    })
                }

            </select>
        </div>
    );
}

export default SelectTeacher;